export enum MetadataTestIds {
  CreateMetadataFieldButton = 'CreateMetadataFieldButton',
  CreateMetadataFieldSubmitButton = 'CreateMetadataFieldSubmitButton',
  EditMetadataFieldSubmitButton = 'EditMetadataFieldSubmitButton',
  MetadataFieldNameInput = 'MetadataFieldNameInput',
  MetadataFieldTypeSelect = 'MetadataFieldTypeSelect',
  MetadataFieldTypeText = 'MetadataFieldTypeText',
  MetadataFieldTypeNumber = 'MetadataFieldTypeNumber',
  MetadataFieldTypeBoolean = 'MetadataFieldTypeBoolean',
  MetadataTable = 'MetadataTable',
  MetadataAddButton = 'MetadataAddButton',
  MetadataEditButton = 'MetadataEditButton',
  MetadataDeleteButton = 'MetadataDeleteButton',
}
